import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'fmPercent',
})
export class FmPercentPipe implements PipeTransform {
  transform(value: number | string, abs?: boolean): string {
    let res = Number(value);
    if (abs) {
      res = Math.abs(res);
    }
    return `${res.toFixed(2)}%`;
  }
}
